import React from 'react';

const TermsPage = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="page-header">
          <h1>Terms & Conditions</h1>
          <p>Last updated: January 2026</p>
        </div>

        <div className="terms-content">
          {/* 100% Guarantee - Front and Center */}
          <section className="terms-section guarantee-section">
            <h2>💯 100% Pass Guarantee</h2>
            <div className="guarantee-box">
              <h3>Our Academic Success Promise</h3>
              <p>
                <strong>We guarantee your academic success with Zed Scholar.</strong> If you use our platform 
                consistently throughout the academic year and do not pass your final exams, 
                we'll provide a <strong>full refund</strong> - no questions asked.
              </p>
              <div className="guarantee-highlights">
                <div className="highlight-item">
                  <span className="checkmark">✓</span>
                  <span>Full refund if you don't pass your exams</span>
                </div>
                <div className="highlight-item">
                  <span className="checkmark">✓</span>
                  <span>Requires consistent platform use throughout the year</span>
                </div>
                <div className="highlight-item">
                  <span className="checkmark">✓</span>
                  <span>No questions asked refund process</span>
                </div>
              </div>
              <p className="guarantee-note">
                <strong>Important:</strong> This guarantee applies only to students who actively use 
                Zed Scholar throughout the academic year and do not achieve a passing grade 
                in their final examinations.
              </p>
            </div>
          </section>

          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Zed Scholar ("the Platform"), you accept and agree 
              to be bound by the terms and provision of this agreement. If you do not 
              agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              Zed Scholar is an online educational platform providing exam preparation 
              materials for Zambian students. Our services include:
            </p>
            <ul>
              <li>Access to past examination papers</li>
              <li>Practice tests and assessments</li>
              <li>AI-powered tutoring assistance</li>
              <li>Progress tracking tools</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Subscription Plans and Payment</h2>
            <h3>Subscription Plans</h3>
            <p>We offer two subscription plans:</p>
            <ul>
              <li>Grade 7 - K500 per year</li>
              <li>Grade 12 - K1000 per year</li>
            </ul>

            <h3>Payment Terms</h3>
            <ul>
              <li>All payments are processed in Zambian Kwacha (ZMW)</li>
              <li>Payments are made via mobile money services</li>
              <li>Subscriptions are valid for 365 days from activation</li>
              <li>Payments are subject to admin approval before account activation</li>
            </ul>

            <h3>Affiliate Program</h3>
            <p>
              We offer an affiliate program where users can get a 20% discount on subscriptions 
              using valid promo codes. Affiliates earn commissions on referred sales. 
              See our affiliate dashboard for more details.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. User Responsibilities</h2>
            <p>As a user of Zed Scholar, you agree to:</p>
            <ul>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Use the platform for educational purposes only</li>
              <li>Not share your account with others</li>
              <li>Not attempt to gain unauthorized access to the system</li>
              <li>Respect intellectual property rights</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Intellectual Property Rights</h2>
            <p>
              All content on Zed Scholar, including but not limited to text, graphics, 
              and study materials, is owned by or licensed to Zed Scholar and 
              is protected by copyright and other intellectual property laws.
            </p>
            <p>
              Users may download materials for personal use only and may not reproduce, 
              distribute, or create derivative works without explicit permission.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Privacy and Data Protection</h2>
            <p>
              We are committed to protecting your privacy. Our Privacy Policy outlines 
              how we collect, use, and protect your personal information. By using our 
              service, you consent to the collection and use of information as described 
              in our Privacy Policy.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Account Suspension and Termination</h2>
            <p>
              We reserve the right to suspend or terminate accounts that violate these 
              terms or engage in prohibited activities. Grounds for termination include:
            </p>
            <ul>
              <li>Sharing account credentials</li>
              <li>Unauthorized reproduction of materials</li>
              <li>System security breaches</li>
              <li>Harassment of other users or staff</li>
              <li>False or misleading information</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              Zed Scholar provides educational materials and services on an "as is" basis. 
              We do not guarantee specific academic outcomes or exam results. Our liability 
              is limited to the subscription fee paid by the user.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Users will be 
              notified of significant changes via email or platform notifications. 
              Continued use of the service constitutes acceptance of modified terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Contact Information</h2>
            <p>
              For questions about these terms or to request support, please contact us:
            </p>
            <ul>
              <li>Email: evans@zedscholarzambia.com</li>
              <li>Phone (Primary): +260962306371</li>
              <li>Phone (Secondary): +260972553255</li>
              <li>Website: https://zedscholarzambia.com</li>
              <li>Address: Lusaka, Zambia</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
